import axios from 'axios';
import { ApiResponseType } from '../../../types/types';
import { ExchangeRequestType } from './TopUp.types';

export const exchangeUsdtToClubAsync = async ({
  amount
}: ExchangeRequestType): Promise<ApiResponseType<any>> => {
  const { data } = await axios.post<ApiResponseType<any>>(
    `/user/balance/exchange/usd-club`,
    {
      amount
    }
  );

  return data;
};

export const exchangeUsdtToMLPAsync = async ({
  amount
}: ExchangeRequestType): Promise<ApiResponseType<any>> => {
  const { data } = await axios.post<ApiResponseType<any>>(
    `/user/balance/exchange/usd-mlp`,
    {
      amount
    }
  );

  return data;
};

export const exchangeClubToMLPAsync = async ({
  amount
}: ExchangeRequestType): Promise<ApiResponseType<any>> => {
  const { data } = await axios.post<ApiResponseType<any>>(
    `/user/balance/exchange/club-mlp`,
    {
      amount
    }
  );

  return data;
};
